<template>
  <div>
    <el-table v-if="blocklist.data && blocklist.data.length"
      :data="blocklist.data"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100"
      stripe
      v-loading="loading"
      @sort-change="sort"
    >
      <el-table-column width="100%">
        <template slot-scope="props">
          <img
            v-if="props.row.image_url"
            class="avatar"
            :src="props.row.image_url"
          />
          <img
            v-else
            class="avatar"
            :src="`https://syncvault.com/static/apple-touch-icon.png`"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="Channel ID"
        prop="channelId"
        sortable="custom"
      ></el-table-column>
      <el-table-column label="Channel Name" prop="title" sortable="custom"></el-table-column>
      <el-table-column label="Added" prop="created_at" sortable="custom">
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="100%">
        <template slot-scope="props">
          <el-tooltip content="Delete" placement="top">
            <el-button
              type="danger"
              circle
              size="small"
              icon="el-icon-close"
              @click="deleteEntry(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <p v-else class="align-center">
      No data
    </p>
    <el-pagination
      class="float-right"
      background
      @current-change="currentChange"
      :current-page.sync="blocklist.current_page"
      :page-size="page_size"
      layout="total, prev, pager, next, jumper"
      :total="blocklist.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('youtubeWhitelist', [
      'blocklist',
      'loading',
      'order_column',
      'order_type',
      'page_size'
    ])
  },
  created() {
    this.readBlockList()
  },
  methods: {
    ...mapMutations('youtubeWhitelist', ['setPage', "setOrdering"]),
    ...mapActions('youtubeWhitelist', ['readBlockList', 'destroyBlocklistEntry']),
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.readBlockList()
    },
    sort(d) { console.log(d)
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readBlockList()
    },
    deleteEntry(row) {
      this.$confirm(
        'You will remove this channel from the blocklist and allowlist!',
        'Warning',
        {
          confirmButtonText: 'Remove',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.destroyBlocklistEntry(row.channelId)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    }
  }
}
</script>
